<template>
  <div id="app">
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
// import queryString from "query-string";
export default {
  name: "App",
  created() {
    // var query = queryString.parse(location.search);
    // if (Object.keys(query).indexOf("shareUrl") > -1) {
    //   console.log("shareurl:", query.shareUrl);
    //   this.$router.push(query.shareUrl);
    // }
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="stylus"></style>
